module.exports = __webpack_public_path__ + "img/bg1.2fae5ed1.png";